// Copyright (c) 2021. Comsearch, Inc., All rights reserved

// prefix will be a string of either:
// "N", "S", "-" or ""

/**
 * returns the derived Latitude Cardinal value
 * @param {String} prefix
 * @returns {string|null}
 */
const deriveDirectionLatitude = prefix => {
  // ensure that the prefix passed here is correct for Latitude
  if (!prefix.match(/^[NS-]?$/)) {
    return null
  }

  return (
    // if the prefix is ether N or S, just return that
    prefix.match(/^[NS]$/) && prefix ||
    // if the prefix indicates that the degrees are negative,
    // then it's in S hemisphere
    prefix === '-' && 'S' ||
    // else the lack of prefix indicates that degrees are positive
    // and that it's the N hemisphere
    'N'
  )
}

export default deriveDirectionLatitude
